declare global {
  interface Window {
    __env: Record<string, string>;
  }
}

interface EnvironmentVariablesConfig {
  API_URL?: string;
  HOT_JAR_SITE_ID: number | undefined;
  HOTJAR_VERSION: number | undefined;
  BUILD_CREATED_AT: string | undefined;
}

const config: EnvironmentVariablesConfig = {
  API_URL: process.env.EXPO_PUBLIC_API_URL ?? window.__env.EXPO_PUBLIC_API_URL,
  HOT_JAR_SITE_ID: isNaN(Number(window.__env.HOT_JAR_SITE_ID))
    ? undefined
    : Number(window.__env.HOT_JAR_SITE_ID),
  HOTJAR_VERSION: isNaN(Number(window.__env.HOTJAR_VERSION))
    ? undefined
    : Number(window.__env.HOT_JAR_VERSION),
  BUILD_CREATED_AT: window.__env.BUILD_CREATED_AT,
};

export default config;
